module.exports = __webpack_public_path__ + "static/media/dropdown_icon.762599c8.svg";